import React from "react";
import ResetPassword from "./Component";

const Container = () => {
  return <ResetPassword />;
};

export default Container;
